import axios from "axios";

const BASEURL = "/api";
export const emailRequest = axios.create({
    baseURL:BASEURL+"/Email"
});